import { SpecialAnchorTypes } from '@labradorsports/constants';

import PlayConfig from './play-config.js';

const { ToolTypes } = PlayConfig;

export const FootballFrameIndices = {
    PRESNAP: 0,
    SNAP: 1,
    MOVEMENT: 2,
};

/** Tool type string → play frame index for football placement and drag (after explicit `frameIdx`). Defaults to MOVEMENT */
const FOOTBALL_TOOL_TYPE_FRAME: Record<string, number> = {
    [ToolTypes.PRESNAP]: FootballFrameIndices.PRESNAP,

    [ToolTypes.SNAP]: FootballFrameIndices.SNAP,
};

/**
 * Resolves the football play frame index for any football tool: passes, moves, and movement anchors
 * from the field (optional explicit `frameIdx` wins). Unlisted move-family types (e.g. `MOVE`,
 * `OMOVE`) default to {@link FootballFrameIndices.MOVEMENT}.
 */
export function getFootballToolFrameIdx(anchor: { frameIdx?: number; type?: string }): number {
    if (typeof anchor.frameIdx === 'number') {
        return anchor.frameIdx;
    }

    const t = anchor.type;
    if (t != null && Object.prototype.hasOwnProperty.call(FOOTBALL_TOOL_TYPE_FRAME, t)) {
        return FOOTBALL_TOOL_TYPE_FRAME[t] as number;
    }

    return FootballFrameIndices.MOVEMENT;
}
